import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { useRequiredParams } from '../../../../../infrastructure/routing'
import { ManagementConfig } from '../../../../../state/configuration'
import { PolicyAdjustmentResultPage } from './PolicyAdjustmentResultPage'
import { PolicyAdjustmentResultPath } from './PolicyAdjustmentResultPath'
import { PolicyAdjustmentReviewPage } from './PolicyAdjustmentReviewPage'

export interface PolicyAdjustmentResultRouterProps {
  config?: ManagementConfig
  onComplete: () => void
  onRepeat: () => void
}

export const PolicyAdjustmentResultRouter: FunctionComponent<
  PolicyAdjustmentResultRouterProps
> = ({ config, onComplete, onRepeat }) => {
  const { adjustmentId } = useRequiredParams<{ adjustmentId: string }>()

  return (
    <Routes>
      <Route
        index
        element={
          <PolicyAdjustmentReviewPage
            adjustmentId={adjustmentId}
            config={config}
            onRepeat={onRepeat}
          />
        }
      />
      <Route
        path={PolicyAdjustmentResultPath.RESULT}
        element={
          <PolicyAdjustmentResultPage
            adjustmentId={adjustmentId}
            onComplete={onComplete}
            onRepeat={onRepeat}
          />
        }
      />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
